import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="10" cy="12" r="9.5" stroke="#DF692B" />
      <path
        d="M8.72 10.62H10.28V16H8.72V10.62ZM9.5 9.87C9.21333 9.87 8.98 9.78667 8.8 9.62C8.62 9.45333 8.53 9.24667 8.53 9C8.53 8.75333 8.62 8.54667 8.8 8.38C8.98 8.21333 9.21333 8.13 9.5 8.13C9.78667 8.13 10.02 8.21 10.2 8.37C10.38 8.53 10.47 8.73 10.47 8.97C10.47 9.23 10.38 9.44667 10.2 9.62C10.02 9.78667 9.78667 9.87 9.5 9.87Z"
        fill="#DF692B"
      />
    </Svg>
  );
};

export default Icon;
